import React from 'react';
import { Link } from 'react-router-dom';

const QuickActionCard = ({ 
  to, 
  title, 
  description, 
  icon, 
  iconColor = 'text-fresh-leaf',
  hoverIconColor = 'group-hover:text-forest-fern',
  titleHoverColor = 'group-hover:text-deep-jungle',
  badge = null,
  onClick,
  disabled = false
}) => {
  const getBadgeStyle = (badgeType) => {
    switch (badgeType) {
      case 'pending':
        return 'bg-info/10 text-info border border-info/20';
      case 'documents':
        return 'bg-warning/10 text-warning border border-warning/20';
      case 'active':
        return 'bg-fresh-leaf/10 text-forest-fern border border-fresh-leaf/20';
      case 'urgent':
        return 'bg-error/10 text-error border border-error/20';
      default:
        return 'bg-steel/10 text-graphite border border-steel/20';
    }
  };

  const getBadgeText = (badgeType) => {
    switch (badgeType) {
      case 'pending': return 'NEW';
      case 'documents': return 'DOCS';
      case 'active': return 'ACTIVE';
      case 'urgent': return 'URGENT';
      default: return badgeType?.toUpperCase() || '';
    }
  };

  const cardContent = (
    <article className={`group relative bg-crystal-white border border-silver-mist transition-all duration-300 hover:border-woodland-moss/40 hover:shadow-soft overflow-hidden ${disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer hover:-translate-y-1 hover:shadow-lg'}`} style={{ borderRadius: '16px' }}>
      {badge && (
        <div className="absolute top-4 right-4 z-10">
          <span className={`inline-flex items-center px-2 py-1 text-xs font-medium uppercase tracking-wider transition-all duration-300 group-hover:shadow-sm ${getBadgeStyle(badge)}`} style={{ borderRadius: '8px' }}>
            {getBadgeText(badge)}
          </span>
        </div>
      )}
      
      <div className="p-6">
        <div className={`inline-flex items-center justify-center w-14 h-14 bg-silver-mist group-hover:bg-fresh-leaf/10 transition-all duration-300 mb-6 ${disabled ? '' : 'group-hover:scale-105 group-hover:shadow-sm'}`} style={{ borderRadius: '12px' }}>
          <svg className={`w-7 h-7 transition-colors duration-300 ${iconColor} ${hoverIconColor}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.5">
            {icon}
          </svg>
        </div>
        
        <div className="space-y-3 mb-6">
          <h3 className={`text-lg font-semibold text-graphite transition-colors duration-300 ${titleHoverColor} leading-tight`}>
            {title}
          </h3>
          
          <p className="text-sm text-steel leading-relaxed group-hover:text-graphite transition-colors duration-300">
            {description}
          </p>
        </div>
        
        <div className="flex items-center justify-between">
          <div className="flex items-center text-fresh-leaf text-sm font-medium group-hover:text-forest-fern transition-colors duration-300">
            <span className="tracking-wide">ACCESS</span>
          </div>
          <svg className="w-5 h-5 text-steel group-hover:text-fresh-leaf group-hover:translate-x-1 transition-all duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-fresh-leaf transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" style={{ borderRadius: '0 0 16px 16px' }}></div>
    </article>
  );

  if (disabled) {
    return cardContent;
  }

  if (onClick) {
    return (
      <button onClick={onClick} className="w-full text-left focus-visible">
        {cardContent}
      </button>
    );
  }

  return (
    <Link to={to} className="block focus-visible">
      {cardContent}
    </Link>
  );
};

export default QuickActionCard;
